/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { useEffect, useState } from 'react'

import { Link } from 'react-router-dom'
import { GrMenu } from 'react-icons/gr'
import { IoMdWallet } from 'react-icons/io'
import { TbLogout } from 'react-icons/tb'
import { RiArrowDropDownLine } from 'react-icons/ri'
import useAuth from 'hooks/useAuth'
import { formatBigNumber } from 'utils/formatBalance'
import useActiveWeb3React from '../hooks/useActiveWeb3React'
import { ConnectWalletOutlinedButton } from './ConnectWalletButton'
import { simpleRpcProvider } from '../utils/providers'
import { DisconnectWalletDarkButton } from './DisconnectWalletButton'
import PhishingWarningBanner from './PhishingWarningBanner'
// import PhishingWarningBanner from './PhishingWarningBanner/index';
// import PhishingWarningBanner from 'components/PhishingWarningBanner';

// const { logout } = useAuth()

// return <button type='button' className='disconnectWalletDarkButton' onClick={() => { logout() }} {...props}>
//   {t('Disconnect')}
// </button>

const Navbar = () => {
  const [isNavbarOpen, setIsNavbarOpen] = useState(false)
  const { account } = useActiveWeb3React()
  const [showDropDown, setShowDropDown] = useState(false)
  const { logout } = useAuth()
  const [bnbBalance, setBnbBalance] = useState('0.0000')

  useEffect(() => {
    const test = async () => {
      if (account) {
        setBnbBalance(formatBigNumber(await simpleRpcProvider.getBalance(account), 6))
      } else {
        setBnbBalance('0.00')
      }
    }
    test()
  }, [account])

  const handleDisconnectWalletClick = () => {
    setShowDropDown(false)
    logout()
  }

  return (
    <>
      <div className="navBarContainer">
        <div className="navBarWrapper">
          <PhishingWarningBanner />
          <nav className="navBar">
            <Link to="/" onClick={() => setIsNavbarOpen(false)}>
              <div className="logoContainer">
                <div className="logoWraper">
                  <img src="images/tokens/hamsterSwapLogo.png" alt="" />
                  <span className="logoTextContainer">
                    {' '}
                    <span>Hamster</span> <span>Swap</span>{' '}
                  </span>
                </div>
              </div>
            </Link>
            <div className="navbar__body">
              <div className="linksContainer">
                <a target='_blank' rel="noreferrer" href='https://marketplace.swaphamster.io'> Marketplace </a>
                {/* <Link to="/contest"> Contest </Link> */}
                <Link to="/swap"> Exchange </Link>
                <Link to="/liquidity"> Liquidity </Link>
                {/* <Link to='/farms' > Farms </Link> */}
                <Link to="/Bab"> BAB </Link>
                {/* <Link to='/launch' > Launch </Link> */}
                {/* <Link to='/nfts' > NFT </Link> */}
              </div>

              <div className="walletInfoContainer">
                <span className="walletMoneyInformation">{bnbBalance} BNB</span>
                {account ? (
                  <span
                    className="connectedWallet"
                    onMouseOver={() => setShowDropDown(true)}
                    onMouseOut={() => setShowDropDown(false)}
                  >
                    <IoMdWallet className="walletIcon" />
                    <span className="accountFormattedAddress">
                      {`${account.substring(0, 4)}..${account.substring(account.length - 3)}`}
                    </span>

                    <RiArrowDropDownLine className="walletDropDownIcon" />

                    <div
                      className="navbar__dropMenuContainer"
                      style={{
                        display: showDropDown ? '' : 'none',
                      }}
                    >
                      <div className="navbar__dropMenuContainer__disconnect" onClick={handleDisconnectWalletClick}>
                        <span>Disconnect</span>
                        <TbLogout className="navbar__dropMenuContainer__disconnect__icon" />
                      </div>
                    </div>
                  </span>
                ) : (
                  <ConnectWalletOutlinedButton />
                )}
              </div>
            </div>

            <button className="hamburgerMenuContainer" onClick={() => setIsNavbarOpen(!isNavbarOpen)} type="button">
              <GrMenu fontSize={20} />
            </button>
          </nav>

          <div
            className="mediumDevicesNavbar"
            style={{
              overflow: 'hidden',
              maxHeight: !isNavbarOpen ? '0px' : '500px',
            }}
          >
            <div className="mediumDevicesNavbar__linksContainer">
              <Link to="/swap" onClick={() => setIsNavbarOpen(false)}>
                {' '}
                Exchange{' '}
              </Link>
              <Link to="/liquidity" onClick={() => setIsNavbarOpen(false)}>
                {' '}
                Liquidity{' '}
              </Link>
              {/* <Link to='/farms' onClick={() => setIsNavbarOpen(false)} > Farms </Link> */}
              <Link to="/pools" onClick={() => setIsNavbarOpen(false)}>
                {' '}
                Pools{' '}
              </Link>

              <Link to="/bab" onClick={() => setIsNavbarOpen(false)}>
                {' '}
                BAB{' '}
              </Link>
              {/* <Link to='/launch' onClick={() => setIsNavbarOpen(false)} > Launch </Link> */}
              {/* <Link to='/nfts' onClick={() => setIsNavbarOpen(false)} > NFT </Link> */}
            </div>

            <div className="mediumDevicesNavbar__walletInfoContainer">
              <span className="mediumDevicesNavbar__walletMoneyInformation">{bnbBalance} BNB</span>
              {account ? (
                <span className="connectedWallet">
                  {' '}
                  <IoMdWallet className="walletIcon" />{' '}
                  <span className="accountFormattedAddress">{`${account.substring(0, 4)}..${account.substring(
                    account.length - 3,
                  )}`}</span>{' '}
                </span>
              ) : (
                <ConnectWalletOutlinedButton />
              )}
            </div>

            <div className="mediumDevicesNavbar__walletInfoContainer">
              {account ? <DisconnectWalletDarkButton /> : <></>}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Navbar
